import { render, staticRenderFns } from "./verifyVip.vue?vue&type=template&id=6645fac0&scoped=true&"
import script from "./verifyVip.vue?vue&type=script&lang=js&"
export * from "./verifyVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645fac0",
  null
  
)

export default component.exports